export default __webpack_public_path__ + "static/media/companyLogo.f486e1e7.png";